// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"193":"d66373c644b21150","963":"de5d604cfe1d1e08","1432":"2df02ffa5ef648cb","5058":"e27b7e659a07a85c","5374":"4b3fdf0c5e1a70a5"}[chunkId] + ".js";
};